
import { createSlice } from "@reduxjs/toolkit";

let initialServiceRequestCreationJourney = {}
const currentServiceRequestCreationJourneySlice = createSlice({
    name: 'currentServiceRequestCreationJourney',
    initialState: initialServiceRequestCreationJourney,
    reducers: {
        setServiceRequestCreationJourney: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetServiceRequestCreationJourney: () => {
            return initialServiceRequestCreationJourney
        }
    },
});

export const { setServiceRequestCreationJourney, resetServiceRequestCreationJourney } = currentServiceRequestCreationJourneySlice.actions;
export default currentServiceRequestCreationJourneySlice.reducer;